import Nav from "../components/marketing/Nav";
import Hero from "../components/marketing/Hero";
import Quiz from "../components/marketing/Quiz";
import Services from "../components/marketing/Services";
import Gallery from "../components/marketing/Gallery";
import Testimonials from "../components/marketing/Testimonials";
import MapSection from "../components/marketing/MapSection";
import BookingSection from "../components/marketing/BookingSection";
import Footer from "../components/marketing/Footer";
import ChatWidget from "../components/marketing/ChatWidget";
import { SiteContentProvider } from "../contexts/SiteContentContext";

export default function Home() {
  return (
    <SiteContentProvider>
      <div data-testid="marketing-home-page" className="bg-[#0A0A0A] min-h-screen">
        <Nav />
        <Hero />
        <Quiz />
        <Services />
        <Gallery />
        <Testimonials />
        <MapSection />
        <BookingSection />
        <Footer />
        <ChatWidget />
      </div>
    </SiteContentProvider>
  );
}
